"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var PlayerDetails_module_css_1 = __importDefault(require("./PlayerDetails.module.css"));
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var q_play_core_1 = require("@nordicscreen/q-play-core");
var material_1 = require("@mui/material");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var q_play_core_2 = require("@nordicscreen/q-play-core");
var timeFormatPattern = "((2[0-3]|[01]?[0-9]):([0-5][0-9]))|(24:00)";
var defaultWeekSchedule = [
    { "turnOnTime": "00:00", "turnOffTime": "24:00" },
    { "turnOnTime": "00:00", "turnOffTime": "24:00" },
    { "turnOnTime": "00:00", "turnOffTime": "24:00" },
    { "turnOnTime": "00:00", "turnOffTime": "24:00" },
    { "turnOnTime": "00:00", "turnOffTime": "24:00" },
    { "turnOnTime": "00:00", "turnOffTime": "24:00" },
    { "turnOnTime": "00:00", "turnOffTime": "24:00" }
];
var BlackScreenSchedule = function (_a) {
    var player = _a.player;
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _b = (0, react_1.useState)(false), scheduleActive = _b[0], setScheduleActive = _b[1];
    var logger = q_play_core_2.logManager.getLogger();
    var weekScheduleDebouncer = (0, react_1.useState)(new q_play_core_1.Debouncer(function (data) {
        ApiManager_1.default.genericApiCall("/api/players/" + player.id + "/setBlackScreenSchedule", "PATCH", data).catch(function (err) {
            logger.error("setBlackScreenSchedule failed:", err);
        }).then(function (response) {
            player.on_off_schedule = JSON.stringify(response.data);
        });
    }, 500))[0];
    var _c = (0, react_1.useState)((player.on_off_schedule === "null" || player.on_off_schedule === null) ? function () {
        weekScheduleDebouncer.debounce(defaultWeekSchedule);
        return defaultWeekSchedule;
    } : JSON.parse(player.on_off_schedule)), weekSchedule = _c[0], setWeekSchedule = _c[1];
    var weekDays = (0, react_1.useMemo)(function () {
        return [
            t("Monday"),
            t("Tuesday"),
            t("Wednesday"),
            t("Thursday"),
            t("Friday"),
            t("Saturday"),
            t("Sunday")
        ];
    }, [t]);
    (0, react_1.useEffect)(function () {
        setScheduleActive(player.on_off_schedule_active);
    }, [player]);
    var toggleSchedule = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ApiManager_1.default.genericApiCall("/api/players/" + player.id + "/toggleBlackScreenSchedule", "PATCH").then(function (value) {
                        setScheduleActive(value);
                        player.on_off_schedule_active = value;
                    }).catch(function (err) {
                        logger.error("toggleBlackScreenSchedule failed", err);
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var saveTurnOffTime = function (e, index) { return __awaiter(void 0, void 0, void 0, function () {
        var field, weekScheduleCopy;
        return __generator(this, function (_a) {
            field = e.currentTarget;
            weekScheduleCopy = JSON.parse(JSON.stringify(weekSchedule));
            weekScheduleCopy[index].turnOffTime = field.value;
            setWeekSchedule(weekScheduleCopy);
            if (!field.validity.patternMismatch && field.value != "" && !field.validity.tooShort) {
                weekScheduleDebouncer.debounce(weekScheduleCopy);
            }
            return [2 /*return*/];
        });
    }); };
    var saveTurnOnTime = function (e, index) { return __awaiter(void 0, void 0, void 0, function () {
        var field, weekScheduleCopy;
        return __generator(this, function (_a) {
            field = e.currentTarget;
            weekScheduleCopy = JSON.parse(JSON.stringify(weekSchedule));
            weekScheduleCopy[index].turnOnTime = field.value;
            setWeekSchedule(weekScheduleCopy);
            if (!field.validity.patternMismatch && field.value != "" && !field.validity.tooShort) {
                weekScheduleDebouncer.debounce(weekScheduleCopy);
            }
            return [2 /*return*/];
        });
    }); };
    var toggleWeekday = function (e, index) { return __awaiter(void 0, void 0, void 0, function () {
        var field, weekScheduleCopy;
        return __generator(this, function (_a) {
            field = e.currentTarget;
            weekScheduleCopy = JSON.parse(JSON.stringify(weekSchedule));
            if (field.getAttribute("data-active") === "true") {
                weekScheduleCopy[index].turnOnTime = "24:00";
                weekScheduleCopy[index].turnOffTime = "00:00";
                field.setAttribute("data-active", "false");
                field.className = PlayerDetails_module_css_1.default.weekday;
            }
            else {
                weekScheduleCopy[index].turnOnTime = "00:00";
                weekScheduleCopy[index].turnOffTime = "24:00";
                field.setAttribute("data-active", "true");
                field.className = PlayerDetails_module_css_1.default.weekdayActive;
            }
            setWeekSchedule(weekScheduleCopy);
            weekScheduleDebouncer.debounce(weekScheduleCopy);
            return [2 /*return*/];
        });
    }); };
    if (player) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: PlayerDetails_module_css_1.default.container },
                react_1.default.createElement("div", { className: "col-sm" },
                    react_1.default.createElement("span", { className: "d-flex ns-font-family-bold ns-font-size-17 mb-3", style: { color: "var(--info-color)" } },
                        t("Energy saver schedule"),
                        ":",
                        react_1.default.createElement(material_1.Tooltip, { title: t("When active, the screen will only turn on in the specified periods. Click on the weekday to quickly toggle on/off state"), placement: "top", arrow: true },
                            react_1.default.createElement("span", null,
                                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faQuestionCircle, color: "var(--info-color)", className: "me-3", style: { width: "20px", height: "20px" } })))),
                    react_1.default.createElement("div", { className: "d-flex align-items-center" },
                        react_1.default.createElement("span", { style: { marginRight: "10px" } },
                            t("Active"),
                            ":"),
                        react_1.default.createElement(q_play_components_1.Switch, { id: "blackScreenScheduleSwitch", checked: scheduleActive, onChange: toggleSchedule, "data-cy": "blackScreenScheduleSwitch" })),
                    react_1.default.createElement("div", { className: "".concat(PlayerDetails_module_css_1.default.scrollableContainer, " col-sm"), style: { height: "375px", paddingRight: "5px" } },
                        react_1.default.createElement("div", { className: "d-flex align-items-center justify-content-around ns-font-family ns-font-size-14" },
                            react_1.default.createElement("div", { className: "ns-font-family-bold text-info", style: { width: "30%" } }, t("Day")),
                            react_1.default.createElement("div", { className: "ns-font-family-bold text-info", style: { width: "30%" } }, t("From")),
                            react_1.default.createElement("div", { className: "ns-font-family-bold text-info", style: { width: "30%" } }, t("To"))),
                        weekSchedule.map(function (day, index) {
                            var weekdayClass = (day.turnOnTime == "00:00" && day.turnOffTime == "24:00") ? PlayerDetails_module_css_1.default.weekdayActive : PlayerDetails_module_css_1.default.weekday;
                            var dataActive = (day.turnOnTime == "00:00" && day.turnOffTime == "24:00") ? "true" : "false";
                            return (react_1.default.createElement("div", { key: index, className: "d-flex align-items-center justify-content-around ns-font-family ns-font-size-14" },
                                react_1.default.createElement("div", { style: { width: "30%" } },
                                    react_1.default.createElement("div", { className: weekdayClass, "data-active": dataActive, onClick: function (e) { toggleWeekday(e, index); }, "data-cy": "weekdayButton" }, weekDays[index])),
                                react_1.default.createElement("div", { style: { width: "30%" } },
                                    react_1.default.createElement(q_play_components_1.Input, { className: PlayerDetails_module_css_1.default.scheduleInput, value: day.turnOnTime, onChange: function (e) { saveTurnOnTime(e, index); }, pattern: timeFormatPattern, minLength: 3, "data-cy": "weekdayTurnOnTimeInput" })),
                                react_1.default.createElement("div", { style: { width: "30%" } },
                                    react_1.default.createElement(q_play_components_1.Input, { className: PlayerDetails_module_css_1.default.scheduleInput, value: day.turnOffTime, onChange: function (e) { saveTurnOffTime(e, index); }, pattern: timeFormatPattern, minLength: 3, "data-cy": "weekdayTurnOffTimeInput" }))));
                        }))))));
    }
};
exports.default = BlackScreenSchedule;
